import { type DropdownMenuCheckboxItemProps } from '@radix-ui/react-dropdown-menu';
import { useFetcher } from '@remix-run/react';
import { type FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '#app/components/ui/button.tsx';
import {
	DropdownMenu,
	DropdownMenuCheckboxItem,
	DropdownMenuContent,
	DropdownMenuLabel,
	DropdownMenuRadioGroup,
	DropdownMenuRadioItem,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from '#app/components/ui/dropdown-menu.tsx';

type Checked = DropdownMenuCheckboxItemProps['checked'];

const LanguagePicker: FC = () => {
	const { t, i18n } = useTranslation();
	const fetcher = useFetcher();

	const onValueChange = (lang: string) => {
		i18n.changeLanguage(lang);
		fetcher.submit(null, {
			method: 'POST',
			action: `/settings/change-language/${lang}`,
		});
	};

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<div className="mx-4 text-sm font-medium text-slate-300 transition duration-150 ease-in-out hover:text-white lg:mx-5">
					{' '}
					{t('root.language')} - {i18n.language.toUpperCase()}
				</div>
			</DropdownMenuTrigger>
			<DropdownMenuContent className="border-none bg-slate-800 shadow-2xl">
				<DropdownMenuRadioGroup
					value={i18n.language}
					onValueChange={onValueChange}
				>
					<DropdownMenuRadioItem
						value="es"
						className="cursor-pointer hover:bg-slate-700"
					>
						<div className="flex gap-2 font-semibold">
							<div>🇪🇸</div>
							<div>{t('root.spanish')}</div>
						</div>
					</DropdownMenuRadioItem>
					<DropdownMenuRadioItem
						value="en"
						className="cursor-pointer hover:bg-slate-700"
					>
						<div className="flex gap-2 font-semibold">
							<div>🇬🇧</div>
							<div>{t('root.english')}</div>
						</div>
					</DropdownMenuRadioItem>
					<DropdownMenuRadioItem
						value="de"
						className="cursor-pointer hover:bg-slate-700"
					>
						<div className="flex gap-2 font-semibold">
							<div>🇩🇪</div>
							<div>{t('root.german')}</div>
						</div>
					</DropdownMenuRadioItem>
				</DropdownMenuRadioGroup>
			</DropdownMenuContent>
		</DropdownMenu>
	);
};

export default LanguagePicker;
